// src/pages/expense/env/total/ExpenseEnvTotalDraftPreviewWindow.jsx
// ✅ 전 사업 확산 [1] 공통화 — 환경/종합 통합 작성 페이지의 PDF 미리보기 전용 창(팝업).
// 실제 로직은 pages/expense/_shared/ExpenseDraftPreviewWindow.jsx(공통 컴포넌트)에 있고,
// 이 파일은 환경/종합 전용 config(envTotalConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
// 라우트 경로/파일명은 리팩터링 전과 동일하게 유지(App.js 변경 없음) — 이 컴포넌트는
// 라우트 element로 직접 쓰여 부모가 props를 못 내려주므로 래퍼가 필요하다.
import React from "react";
import ExpenseDraftPreviewWindow from "../../_shared/ExpenseDraftPreviewWindow";
import envTotalConfig from "./envTotalConfig";

export default function ExpenseEnvTotalDraftPreviewWindow() {
  return <ExpenseDraftPreviewWindow config={envTotalConfig} />;
}
